/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { Center, useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import { type GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      ['Node-Mesh']: Mesh
      ['Node-Mesh_1']: Mesh
      ['Node-Mesh_2']: Mesh
    }
    materials: {
      Office_Cha: MeshStandardMaterial
      Office_Cha_1: MeshStandardMaterial
      Office_Cha_2: MeshStandardMaterial
    }
  }

export function Chair(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/chair.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <Center position-y={19.8}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Node-Mesh'].geometry}
          material={materials.Office_Cha}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Node-Mesh_1'].geometry}
          material={materials.Office_Cha_1}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['Node-Mesh_2'].geometry}
          material={materials.Office_Cha_2}
        />
      </Center>
    </group>
  )
}

useGLTF.preload('/models/chair.glb')
